import React, { useState } from "react";
import MDBox from "shared/ui/Box/MDBox";
import MDTypography from "shared/ui/Typography/MDTypography";
import CircularProgress from "@mui/material/CircularProgress";
import Icon from "@mui/material/Icon";
import usePlanner from "features/planner/state/usePlanner";
import logger from "utils/logger";

const MIN_LOADING_DURATION_MS = 600;

export default function PreviewPdfButton() {
  const { generateProgramPdf } = usePlanner();
  const [isLoading, setIsLoading] = useState(false);

  const handlePreview = async () => {
    if (isLoading) return;

    const minimumLoadingDuration = new Promise((resolve) =>
      setTimeout(resolve, MIN_LOADING_DURATION_MS)
    );

    setIsLoading(true);

    try {
      logger.info("Previewing PDF");

      const { blob } = await generateProgramPdf();
      const url = URL.createObjectURL(blob);

      await minimumLoadingDuration;
      window.open(url, "_blank");
    } catch (err) {
      logger.error("Error previewing PDF", err);
    } finally {
      await minimumLoadingDuration;
      setIsLoading(false);
    }
  };

  return (
    <MDBox
      component="button"
      type="button"
      onClick={handlePreview}
      disabled={isLoading}
      aria-busy={isLoading}
      sx={{
        width: { xs: "100%", md: "90%", lg: "100%" },
        maxWidth: "260px",
        paddingY: "8px",
        paddingX: "14px",
        borderRadius: "12px",
        cursor: isLoading ? "wait" : "pointer",
        userSelect: "none",
        opacity: isLoading ? 0.7 : 1,

        border: "1.5px solid",
        borderColor: "secondary.main",
        backgroundColor: "background.paper",
        color: "secondary.main",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",

        transition: "all 0.18s ease",

        "&:hover:not(:disabled)": {
          backgroundColor: "grey.100",
          borderColor: "secondary.focus",
          color: "secondary.focus",
        },

        "&:active:not(:disabled)": {
          transform: "scale(0.98)",
        },
      }}
    >
      {isLoading ? (
        <CircularProgress size={18} thickness={5} color="inherit" aria-hidden="true" />
      ) : (
        <Icon sx={{ fontSize: 18, color: "inherit" }}>picture_as_pdf</Icon>
      )}

      <MDTypography
        sx={{
          fontSize: "0.85rem",
          fontWeight: 600,
          color: "inherit",
          lineHeight: 1,
        }}
      >
        {isLoading ? "Generando PDF..." : "Previsualizar PDF"}
      </MDTypography>
    </MDBox>
  );
}
